import { render, staticRenderFns } from "./OrderVolume.vue?vue&type=template&id=3ad9a6f6&scoped=true&"
import script from "./OrderVolume.vue?vue&type=script&lang=js&"
export * from "./OrderVolume.vue?vue&type=script&lang=js&"
import style0 from "./OrderVolume.vue?vue&type=style&index=0&id=3ad9a6f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad9a6f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
